/*
 * Copyright (c) 2023 Powerledger Pty Ltd. All Rights Reserved.
 */

import { Box, Flex, Heading, IconLinkThin, IconLoading, SquareBlock } from "@powerledger/ui-component-lib";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { RegistryForm } from "@/app/components/layout/registry-modal/registry-form";

import { LinkedRegistriesViewProps } from "./linked-registries.types";
import { LinkedRegistryBlock } from "./linked-registry-block";

export const LinkedRegistriesView: FC<LinkedRegistriesViewProps> = ({
  showModal,
  refetchRegistries,
  canLinkRegistry,
  loading,
  linkedRegistries,
  showRegistryModal,
  setOpenForm,
  linkedRegistryText,
  openForm,
  selectedRegistry,
  setSelectedRegistry,
}) => {
  const { t } = useTranslation();
  const gridContent = useMemo(() => {
    const handleOpenForm = () => {
      showModal ? showRegistryModal({}) : setOpenForm && setOpenForm(true);
    };
    return (
      <>
        {linkedRegistries.length > 0 &&
          linkedRegistries.map((linkedRegistry) => (
            <LinkedRegistryBlock
              key={linkedRegistry?.id}
              registry={linkedRegistry}
              refetchRegistries={refetchRegistries}
              loading={loading}
            />
          ))}
        {canLinkRegistry && (
          <SquareBlock
            isEmpty
            onClick={handleOpenForm}
            sx={{ width: ["100%", null, null, "50%"], maxWidth: 300, px: 2 }}
          >
            <>
              <IconLinkThin stroke="primary.500" size={128} />
              <Box sx={{ mt: 4, textAlign: "center" }} data-testid={"linked-registries--link"}>
                {t("LINK TO REGISTRY")}
              </Box>
            </>
          </SquareBlock>
        )}
      </>
    );
  }, [canLinkRegistry, linkedRegistries, loading, refetchRegistries, setOpenForm, showModal, showRegistryModal, t]);
  return (
    <>
      {loading && (
        <Flex sx={{ justifyContent: "center" }}>
          <IconLoading />
        </Flex>
      )}
      {!loading &&
        (!openForm ? (
          <>
            {!showModal && (
              <Flex sx={{ mb: 4, justifyContent: "space-between", alignItems: "center" }}>
                <Heading as="h2">{linkedRegistryText}</Heading>
              </Flex>
            )}
            <Flex sx={{ flexWrap: "wrap", mx: -2, mt: 4 }}>{gridContent}</Flex>
          </>
        ) : (
          <RegistryForm
            closeModal={() => setOpenForm && setOpenForm(false)}
            selectedRegistry={selectedRegistry}
            setSelectedRegistry={setSelectedRegistry}
            singlePage
            showModal={false}
          />
        ))}
    </>
  );
};
